import { onPath } from '../utils/path';
import {detectFreeEmailDomain} from '../utils/detect-free-email-domain';
import {getWindow, selectOne, removeClass} from '../utils/dom-utils';
import getParameterByName from '../utils/url';

/*
  We are limiting the A/B test participants, to just people with NON FREE email addresses, for initial release.
  We will shortly add Gov/EDU to the mix.
*/

function showMainDiv(){
  removeClass(selectOne(".begin-signup"), "tw-invisible");
}

onPath('/onboarding/hello*', () => {
  const win = getWindow();
  const email = getParameterByName('email');
  const isFreeDomain = detectFreeEmailDomain(email);
  const legacyRedirect = getParameterByName('legacyRedirect');
  const continueButton = selectOne('#continue-to-dashboard');

  if(isFreeDomain){
    document.location = '/dashboard';
  }else {
    // check for redirection URL for now, to see if it's a no-CC trial
    var isNoCCTrial = (legacyRedirect && legacyRedirect.match('team'));

    if(isNoCCTrial){
      //continueButton.href="/signup/team";

      // uncomment this, to send .gov and .edu and other no-cc-trial directly into flow
      document.location = '/signup/team';
    }else{
      //showMainDiv();
      document.location = '/dashboard';
    }
  }

});